/*
 * @Descripttion:百姓墙运营商
 * @Author: lc
 * @Date: 2021-10-25 08:33:06
 * @LastEditors: may.li
 * @LastEditTime: 2023-04-28 11:46:36
 */
import axios from '../../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const baixingqiang = {
    // 列表
    arealist (params) {
        return axios.get(api + 'baixingqiang/arealist', { params: params })
    },
    //添加
    areacreate (params) {
        return axios.post(api + 'baixingqiang/areacreate', qs.stringify(params))
    },
    //获取编辑信息
    areadetail (params) {
        return axios.get(api + 'baixingqiang/areadetail', { params: params })
    },
    //修改
    areaedit (params) {
        return axios.post(api + 'baixingqiang/areaedit', qs.stringify(params))
    },
    //删除
    arearemove (params) {
        return axios.post(api + 'baixingqiang/arearemove', qs.stringify(params))
    },
	// 状态
	areastatus(params){
		return axios.post(api + 'baixingqiang/areastatus', qs.stringify(params))
	},
	// 获取所有表格
	alltabledata(params){
		return axios.get(api + 'baixingqiang/alltabledata', { params: params })
	},
	// 获取单个表格数据
	tabledata(params){
		return axios.get(api + 'baixingqiang/tabledata', { params: params })
	},
	// 单个表格编辑数据
	createtabledata(params){
		return axios.post(api + 'baixingqiang/createtabledata', qs.stringify(params))
	}
}


// 导出接口
export default baixingqiang


